import { render, staticRenderFns } from "./RegistroMadrillaDetail.vue?vue&type=template&id=9c7912c4"
import script from "./RegistroMadrillaDetail.vue?vue&type=script&lang=js"
export * from "./RegistroMadrillaDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports